// A place to keep your menu scripting (ex. toggling a mobile menu)
(function($){

	// Mobile Menus
	$(".main-menu-toggle").click(function() {
		mainNav();
	});

	function mainNav() {
		$(".main-menu-toggle").toggleClass("cross");
		$("body").toggleClass("modal-open no-scroll");
		$("#site-navigation").toggleClass("open");
	}

// 	// (just an example below change it to suit your needs)
// 	//Listen for menu clicks with anchors, to close the menu 
// 	$(document).on('click', '.menus.open li.current-menu-item a:not(.expand)', function() {
// 		mainNav();
// 	});
	

	$.each($('#site-navigation li.menu-item-has-children'), function (index, value) {
		$(this).children('a').append($('<span class="arrow"></span>'));
	});


	// init responsive
	menuStuff();

	$(window).resize(function () {
		menuStuff();
	});

	$('#nav-icon').click(function(e){
		e.preventDefault();
		$(this).toggleClass('is-active');
	});


	function menuStuff() {

		var menu_element = $('.menu li');
		var arrow = $('.menu-item-has-children span.arrow');

		//unbind li click event
		menu_element.unbind();

		arrow.unbind().click(function (e) {

			e.preventDefault();

			if( $(this).closest('li').children('ul').hasClass( "sub-menu" ) ){
				var level = '.sub-menu';
				var element = $(this);
				xsScreen(element, level);

			}
		});

		function xsScreen(element, level) {

			if( element.closest('li').children(level).hasClass('open') ){

				element.closest('li').children(level).slideUp(250).removeClass("open");
				element.parent('a').removeClass("active-parent");
				element.removeClass("open");

			}else{

				element.closest('li').children(level).slideDown(250).addClass('open');
				element.parent('a').addClass("active-parent");
				element.addClass("open");
			}
		}
	}


})(jQuery);

